export default __webpack_public_path__ + "static/media/team-kirsten.642f37cf.png";